import { compose, withHandlers } from 'recompose';

import SuggestedItem from 'components/form/SuggestedTimes/SuggestedItem/component';

const enhance = compose(
  withHandlers({
    handleClick:
      ({ onClick, value, diffDay }) =>
      () => {
        onClick({ value, diffDay });
      },
  })
);

export default enhance(SuggestedItem);
